import React from 'react';
import './modal.scss';
import Error from './components/error';
import Visitor10k from './components/visitor10k';
import Success10k from './components/success10k';
import About from './components/about';
import Downloads from './components/downloads';

const Modal = ({config, handleModal}) => {
    const {open, content} = config;

    let modalContent 

    switch (content) {
        case 'error':
          modalContent = <Error/>;
          break;
        case '10k':
          modalContent = <Visitor10k/>;
          break;
        case 'success10k':
          modalContent = <Success10k/>;
        break;
        case 'about':
          modalContent = <About/>;
        break;
        case 'downloads':
          modalContent = <Downloads/>
        break;
        default:
          modalContent = <p>{content}</p>;
          break;
    }

    const reset = content === '10k' ? '10k' : undefined;

    return (
        open && <div className="modal_overlay">
        <div className='modal'>
            {modalContent}
            <button className="modal-close" onClick={() => handleModal({open: false, content: reset})} aria-label="Close" type="button"/>
        </div>            
    </div>
    );
}

export default Modal;